import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams} from 'react-router-dom';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';

// Enum options for timing and relativeToMeal
const TIMING_OPTIONS = [
  { value: 'MORNING', label: 'Morning' },
  { value: 'AFTERNOON', label: 'Afternoon' },
  { value: 'EVENING', label: 'Evening' },
  { value: 'NIGHT', label: 'Night' }
];

const RELATIVE_TO_MEAL_OPTIONS = [
    { value: 'BEFORE_MEAL', label: 'Before MEAL' },
  { value: 'AFTER_MEAL', label: 'After MEAL' },
  // { value: 'BEFORE_BREAKFAST', label: 'Before Breakfast' },
  // { value: 'AFTER_BREAKFAST', label: 'After Breakfast' },
  // { value: 'BEFORE_LUNCH', label: 'Before Lunch' },
  // { value: 'AFTER_LUNCH', label: 'After Lunch' },
  // { value: 'BEFORE_EVENING', label: 'Before Evening' },
  // { value: 'AFTER_EVENING', label: 'After Evening' },
  // { value: 'BEFORE_DINNER', label: 'Before Dinner' },
  // { value: 'AFTER_DINNER', label: 'After Dinner' }
];

const emptyPrescription = {
  medicineName: '',
  durationInDays: '',
  totalQuantity: '',
  dosage: [
    {
      quantity: '',
      timing: '',
      relativeToMeal: ''
    }
  ]
};

const emptyTest = {
  testId: '',
  testName: '',
  testDescription: '',
  notes: ''
};

const PrescriptionsPage = () => {
  const { patientId } = useParams();
  const { user, token } = useAuth();
  const [records, setRecords] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [form, setForm] = useState({
    recordDate: '',
    diagnosis: '',
    treatment: '',
    notes: '',
    prescriptions: [{ ...emptyPrescription }],
    recommendedTests: [{ ...emptyTest }]
  });

  // useEffect(() => {
  //   if (patientId && !isNaN(Number(patientId))) {
  //     fetchRecords();
  //     fetchMedicines();
  //   }
  //   // eslint-disable-next-line
  // }, [patientId]);

  const fetchMedicines = async () => {
    try {
      const res = await axios.get(`${API_PATH}/medicines`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMedicineList(res.data);
    } catch (error) {
      console.error('Error fetching medicines:', error);
    }
  };

  // const fetchRecords = async () => {
  //   try {
  //     const res = await axios.get(`${API_PATH}/medicalrecords/${patientId}`, {
  //       headers: { Authorization: `Bearer ${token}` }
  //     });
  //     setRecords(res.data);
  //   } catch (err) {
  //     console.error('Error fetching records:', err);
  //   }
  // };

  // Ensure datetime-local includes seconds
  
const fetchRecords = async () => {
  try {
    console.log('Fetching records for patientId:', patientId);
    console.log('Using token:', token);
    const res = await axios.get(`${API_PATH}/medicalrecords/${patientId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log('API Response:', res.data);
    // setRecords(Array.isArray(res.data) ? res.data : Array.isArray(res.data.data) ? res.data.data : []);
    setRecords(res.data);
  } catch (err) {
    console.error('Error fetching records:', err.response?.data || err.message);
    // setRecords([]);
  }
};

useEffect(() => {
  console.log('useEffect triggered with patientId:', patientId);
  if (patientId && !isNaN(Number(patientId))) {
    fetchRecords();
    fetchMedicines();
  }
}, [patientId]);
  
  
  const formatDateWithSeconds = (value) => {
    if (!value) return '';
    if (value.length === 19) return value.replace('T', ' ');
    if (value.length === 16) return value.replace('T', ' ') + ':00';
    return value.replace('T', ' ');
  };

  // Prescription handlers
  const handlePrescriptionChange = (idx, field, value) => {
    const updated = [...form.prescriptions];
    updated[idx][field] = value;
    setForm({ ...form, prescriptions: updated });
  };

  const handleDosageChange = (prescIdx, dosageIdx, field, value) => {
    const updated = [...form.prescriptions];
    updated[prescIdx].dosage[dosageIdx][field] = value;
    setForm({ ...form, prescriptions: updated });
  };

  const addPrescription = () => {
    setForm({
      ...form,
      prescriptions: [...form.prescriptions, { ...emptyPrescription }]
    });
  };

  const removePrescription = (idx) => {
    const updated = form.prescriptions.filter((_, i) => i !== idx);
    setForm({
      ...form,
      prescriptions: updated.length ? updated : [{ ...emptyPrescription }]
    });
  };

  const addDosage = (prescIdx) => {
    const updated = [...form.prescriptions];
    updated[prescIdx].dosage.push({
      quantity: '',
      timing: '',
      relativeToMeal: ''
    });
    setForm({ ...form, prescriptions: updated });
  };

  const removeDosage = (prescIdx, dosageIdx) => {
    const updated = [...form.prescriptions];
    updated[prescIdx].dosage = updated[prescIdx].dosage.filter((_, i) => i !== dosageIdx);
    if (updated[prescIdx].dosage.length === 0) {
      updated[prescIdx].dosage = [
        {
          quantity: '',
          timing: '',
          relativeToMeal: ''
        }
      ];
    }
    setForm({ ...form, prescriptions: updated });
  };

  // Test handlers
  const handleTestChange = (idx, field, value) => {
    const updated = [...form.recommendedTests];
    updated[idx][field] = value;
    setForm({ ...form, recommendedTests: updated });
  };

  const addTest = () => {
    setForm({
      ...form,
      recommendedTests: [...form.recommendedTests, { ...emptyTest }]
    });
  };

  const removeTest = (idx) => {
    const updated = form.recommendedTests.filter((_, i) => i !== idx);
    setForm({
      ...form,
      recommendedTests: updated.length ? updated : [{ ...emptyTest }]
    });
  };

  const normalizePrescriptionEnums = (prescriptions) =>
    prescriptions.map((p) => ({
      ...p,
      durationInDays: p.durationInDays ? Number(p.durationInDays) : 0,
      dosage: p.dosage.map((d) => ({
        ...d,
        timing: (d.timing || '').toUpperCase(),
        relativeToMeal: (d.relativeToMeal || '').toUpperCase()
      }))
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!patientId || isNaN(Number(patientId))) {
      alert('Invalid patient ID.');
      return;
    }
    try {
      const payload = {
        ...form,
        recordDate: formatDateWithSeconds(form.recordDate),
        attendingDoctorId: user.id,
        patientId: parseInt(patientId),
        prescriptions: normalizePrescriptionEnums(form.prescriptions)
      };
      await axios.post(`${API_PATH}/medicalrecords/patients/${patientId}/records`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRecords();
      setForm({
        recordDate: '',
        diagnosis: '',
        treatment: '',
        notes: '',
        prescriptions: [{ ...emptyPrescription }],
        recommendedTests: [{ ...emptyTest }]
      });
    } catch (error) {
      console.error('Error saving record:', error);
      alert('Error saving record. Please check your input.');
    }
  };

  const handleDelete = async (id) => {
  if (window.confirm('Are you sure you want to delete this medical record?')) {
    try {
      await axios.delete(`${API_PATH}/medicalrecords/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRecords(); // Refresh list
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Failed to delete the record.');
    }
  }
};



  return (

<div className="container py-5 w-100 mw-100">
  <h4 className="mb-5 text-primary fw-bold">Prescriptions for Patient #{patientId} {records.diagnosis}</h4>

  {!patientId || isNaN(Number(patientId)) ? (
    <div className="alert alert-danger fs-5">
      Invalid patient ID. Please check the URL or select a patient.
    </div>
  ) : (
    <div className="card shadow-lg mb-5">
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Record Date</label>
              <input
                type="datetime-local"
                className="form-control"
                value={form.recordDate}
                onChange={(e) => setForm({ ...form, recordDate: e.target.value })}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold">Diagnosis</label>
              <input
                type="text"
                className="form-control"
                value={form.diagnosis}
                onChange={(e) => setForm({ ...form, diagnosis: e.target.value })}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold">Treatment</label>
              <input
                type="text"
                className="form-control"
                value={form.treatment}
                onChange={(e) => setForm({ ...form, treatment: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label fw-semibold">Notes</label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Additional notes..."
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
            />
          </div>

          <hr className="my-5" />

   


          <div className="mb-5 border shadow rounded px-4 py-4">
  <label className="form-label fw-bold fs-5 mb-3 d-block">Prescriptions</label>
  {form.prescriptions.map((presc, idx) => (
    <div key={idx} className="card card-body mb-4  shadow rounded-3 shadow border px-2 py-2">
      {/* Main Prescription Row */}
      <div className="row g-2 align-items-center">
        <div className="col-md-4">
          <select
            className="form-select"
            value={presc.medicineName}
            onChange={(e) => handlePrescriptionChange(idx, 'medicineName', e.target.value)}
            required
          >
            <option value="">Select Medicine</option>
            {medicineList.map((med) => (
              <option key={med.id} value={med.name}>
                {med.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <input
            type="number"
            placeholder="Duration (days)"
            className="form-control"
            value={presc.durationInDays}
            onChange={(e) => handlePrescriptionChange(idx, 'durationInDays', e.target.value)}
            required
            min={1}
          />
        </div>
        <div className="col-md-3">
          <input
            type="number"
            placeholder="Total Quantity"
            className="form-control"
            value={presc.totalQuantity}
            onChange={(e) => handlePrescriptionChange(idx, 'totalQuantity', e.target.value)}
            required
            min={1}
          />
        </div>
        <div className="col-md-2 text-end">
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => removePrescription(idx)}
            title="Remove Prescription"
            //style={{ width: '36px', height: '36px', lineHeight: '18px' }}
          >
            &times; Remove
          </button>
        </div>
      </div>

      {/* Dosage Section */}
      <div className='shadow border pb-2 px-2 rounded'>
      {presc.dosage.map((dose, doseIdx) => (
        <div key={doseIdx} className="row g-2 mt-3 align-items-center ">
          <div className="col-md-3">
            <input
              type="text"
              placeholder="Quantity"
              className="form-control"
              value={dose.quantity}
              onChange={(e) => handleDosageChange(idx, doseIdx, 'quantity', e.target.value)}
              required
            />
          </div>
          <div className="col-md-3">
            <select
              className="form-select"
              value={dose.timing}
              onChange={(e) => handleDosageChange(idx, doseIdx, 'timing', e.target.value)}
              required
            >
              <option value="">Select Timing</option>
              {TIMING_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <select
              className="form-select"
              value={dose.relativeToMeal}
              onChange={(e) => handleDosageChange(idx, doseIdx, 'relativeToMeal', e.target.value)}
              required
            >
              <option value="">Relative to Meal</option>
              {RELATIVE_TO_MEAL_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 text-end">
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => removeDosage(idx, doseIdx)}
              //style={{ width: '32px', height: '32px', lineHeight: '16px' }}
              title="Remove Dosage"
            >
              &times; Remove
            </button>
          </div>
        </div>
      ))}

      {/* Add Dosage Button */}
      <div className="mt-3 text-start">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm mt-2 w-40"
          onClick={() => addDosage(idx)}
        >
          + Add Dosage
        </button>
      </div>
    </div>
    </div>
  ))}

  {/* Add Prescription Button */}
  <button
    type="button"
    className="btn btn-outline-primary btn-sm mt-2 w-40"
    onClick={addPrescription}
  >
    + Add Prescription
  </button>
</div>


    

    
<div className="mb-4 border shadow rounded px-4 py-4">
  <label className="form-label fw-bold">Recommended Tests</label>
  {form.recommendedTests.map((test, idx) => (
    <div key={idx} className="card card-body mb-2 border shadow">
      <div className="row g-2 align-items-center">
        <div className="col-md-3">
          <input
            type="text"
            placeholder="Test Name"
            className="form-control"
            value={test.testName}
            onChange={(e) => handleTestChange(idx, 'testName', e.target.value)}
            required
          />
        </div>
        <div className="col-md-4">
          <input
            type="text"
            placeholder="Test Description"
            className="form-control"
            value={test.testDescription}
            onChange={(e) => handleTestChange(idx, 'testDescription', e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <input
            type="text"
            placeholder="Notes"
            className="form-control"
            value={test.notes}
            onChange={(e) => handleTestChange(idx, 'notes', e.target.value)}
          />
        </div>
        <div className="col-md-2 text-end">
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => removeTest(idx)}
            title="Remove Test"
          >
            &times; Remove
          </button>
        </div>
      </div>
    </div>
  ))}
  <button
    type="button"
    className="btn btn-outline-primary btn-sm mt-2 w-40"
    onClick={addTest}
  >
    + Add Test
  </button>
</div>


          <div className="text-center">
            <button type="submit" className="btn btn-success px-5 py-2 fw-semibold fs-5  rounded-pill w-50 ">
              Submit Record
            </button>
          </div>
        </form>
      </div>
    </div>
  )}

  {/* Existing Records Section */}
  <h4 className="mt-5 mb-4 text-secondary fw-semibold">Existing Records</h4>
  {records.length === 0 ? (
    <div className="alert alert-warning fs-6">
      No records found for this patient.
    </div>
  ) : (
    <div className="table-responsive shadow-sm rounded">
      <table className="table table-striped table-bordered align-middle mb-0">
        <thead className="table-primary">
          <tr>
            <th>Date</th>
            <th>Diagnosis</th>
            <th>Treatment</th>
            <th>Notes</th>
            <th>Prescriptions</th>
            <th>Recommended Tests</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
         
            <tr  className="align-top">
              <td>{new Date(records.recordDate).toLocaleString()}</td>
              <td>{records.diagnosis}</td>
              <td>{records.treatment}</td>
              <td>{records.notes}</td>
              <td style={{ minWidth: '220px' }}>
                {records.prescriptions?.length ? (
                  <ul className="mb-0 ps-3">
                    {records.prescriptions.map((p, i) => (
                      <li key={i}>
                        <strong>{p.medicineName}</strong> ({p.duration} days)
                        <ul className="mb-0 ps-3">
                          {p.dosage.map((d, j) => (
                            <li key={j}>
                              {d.quantity} - {d.timing} ({d.relativeToMeal})
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <em>No prescriptions</em>
                )}
              </td>
              <td style={{ minWidth: '220px' }}>
                {records.recommendedTests?.length ? (
                  <ul className="mb-0 ps-3">
                    {records.recommendedTests.map((t, i) => (
                      <li key={i}>
                        <strong>{t.testName}</strong>
                        {t.testDescription && `: ${t.testDescription}`}
                        {t.notes && (
                          <div>
                            <em>Note:</em> {t.notes}
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <em>No tests</em>
                )}
              </td>

               <button
              className="btn btn-sm btn-warning me-2"
              onClick={() => alert("Edit functionality not implemented yet.")}
            >
              Edit
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handleDelete(records.id)}
            >
              Delete
            </button>

            </tr>
   
        </tbody>
      </table>
    </div>
  )}


{/* <h4 className="mt-5 mb-4 text-secondary fw-semibold">Existing Records</h4>
{!Array.isArray(records) || records.length === 0 ? (
  <div className="alert alert-warning fs-6">
    No records found for this patient.
  </div>
) : (
  <div className="table-responsive shadow-sm rounded">
    <table className="table table-striped table-bordered align-middle mb-0">
      <thead className="table-primary">
        <tr>
          <th>Date</th>
          <th>Diagnostic</th>
          <th>Treatment</th>
          <th>Notes</th>
          <th>Prescriptions</th>
          <th>Recommended Tests</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
      
        {records.map((rec) => (
          <tr key={rec.id || `record-${rec.recordDate}-${Math.random()}`} className="align-top">
            <td>
              {rec.recordDate
                ? new Date(rec.recordDate).toLocaleString()
                : 'Invalid Date'}
            </td>
            <td>{rec.diagnosis || 'N/A'} <p></p></td>
            <td>{rec.treatment || 'N/A'}</td>
            <td>{rec.notes || 'N/A'}</td>
            <td style={{ minWidth: '220px' }}>
              {Array.isArray(rec.prescriptions) && rec.prescriptions.length > 0 ? (
                <ul className="mb-0 ps-3">
                  {rec.prescriptions.map((p, i) => (
                    <li key={`prescription-${i}`}>
                      <strong>{p.medicineName || 'Unknown Medicine'}</strong> (
                      {p.durationInDays ? `${p.durationInDays} days` : 'N/A'})
                      <ul className="mb-0 ps-3">
                        {Array.isArray(p.dosage) && p.dosage.length > 0 ? (
                          p.dosage.map((d, j) => (
                            <li key={`dosage-${j}`}>
                              {d.quantity || 'N/A'} - {d.timing || 'N/A'} (
                              {d.relativeToMeal || 'N/A'})
                            </li>
                          ))
                        ) : (
                          <li>No dosage specified</li>
                        )}
                      </ul>
                    </li>
                  ))}
                </ul>
              ) : (
                <em>No prescriptions</em>
              )}
            </td>
            <td style={{ minWidth: '220px' }}>
              {Array.isArray(rec.recommendedTests) && rec.recommendedTests.length > 0 ? (
                <ul className="mb-0 ps-3">
                  {rec.recommendedTests.map((t, i) => (
                    <li key={`test-${i}`}>
                      <strong>{t.testName || 'Unknown Test'}</strong>
                      {t.testDescription && `: ${t.testDescription}`}
                      {t.notes && (
                        <div>
                          <em>Note:</em> {t.notes}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <em>No tests</em>
              )}
            </td>
            <td>
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() => alert('Edit functionality not implemented yet.')}
              >
                Edit
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDelete(rec.id)}
                disabled={!rec.id}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)} */}
 
</div>

  );
};

export default PrescriptionsPage;
